import { useGame } from "../../../data/gameContext";

export default function GeneralStore() {
    const {updateGameState} = useGame();
    return (
        <div className="town-container">
            The General Store
            <button onClick={() => updateGameState({Phase: 'townView'})}>Leave</button>
        </div>
    )
}